module.exports = __webpack_public_path__ + "media/app/assets/classes/warrior-6c12d3a3c190068f808fe943f635e4a8.jpg";